import LoginButton from 'components/LoginButton';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';
import './index.css';
import { useTranslation } from 'react-i18next';
import { Loader } from 'semantic-ui-react';
import { useEffect, useState } from 'react';
import {
  FOREVER_PRODUCT_ID,
  MONTHLY_PRODUCT_ID,
  YEARLY_PRODUCT_ID
} from '../../services/iosPurchases';

const Upgrade = ({ user, subscriptions }) => {
  console.log(subscriptions, 'subscriptions');

  const { t } = useTranslation();
  const { store, Platform } = window.CdvPurchase;
  const [loading, setLoading] = useState('');
  const [error, setError] = useState('');

  const yearlyProduct = store.get(YEARLY_PRODUCT_ID, Platform.APPLE_APPSTORE);
  const monthlyProduct = store.get(MONTHLY_PRODUCT_ID, Platform.APPLE_APPSTORE);
  const foreverProduct = store.get(FOREVER_PRODUCT_ID, Platform.APPLE_APPSTORE);

  const handleOrder = async (type, product) => {
    setLoading(type);
    setError('');

    try {
      const response = await product.getOffer().order();

      if (response?.isError) {
        setError(response?.message ?? 'Something go wrong, please try later.');
      }

      setLoading('');
    } catch (error) {
      setError('Something go wrong, please try later.');
      setLoading('');
    }
  };

  if (!user.inSignedIn) {
    return (
      <Message warning size="large">
        <Message.Header>{t('messages.please_login')}</Message.Header>
        <Message.Content>
          <LoginButton />
        </Message.Content>
      </Message>
    );
  }

  return (
    <div className="mt-6">
      {error && (
        <Message error>
          <Message.Header>{error}</Message.Header>
        </Message>
      )}

      <div className="ui grid stackable container upgradeContent">
        {!subscriptions.receipt && (
          <div className="row">
            <div className="column">
              <h2 className="ui header text-center">Free trial 7 days</h2>
            </div>
          </div>
        )}
        <div className="three column row">
          {monthlyProduct?.title && (
            <div className="column">
              <div className="ui card fluid">
                <div className="content">
                  <div className="header">{t('plans.Monthly')}</div>
                </div>
                <div className="content">
                  <h2 className="ui header">
                    {`${monthlyProduct.offers[0].pricingPhases[
                      monthlyProduct.offers[0].pricingPhases.length - 1
                    ].priceMicros / 1000000
                      } ${monthlyProduct.offers[0].pricingPhases[
                        monthlyProduct.offers[0].pricingPhases.length - 1
                      ].currency
                      }`}
                  </h2>
                  <p className="ui header">{t('plans.MonthlyDescription')}</p>
                </div>
                <div className="extra content">
                  <button
                    className="ui button primary"
                    onClick={() => {
                      handleOrder('monthly', monthlyProduct);
                    }}
                  >
                    {loading === 'monthly' ? (
                      <Loader size="tiny" active inline="centered" />
                    ) : (
                      t('buttons.btn_upgrade')
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
          {yearlyProduct?.title && (
            <div className="column">
              <div className="ui card fluid">
                <div className="content">
                  <div className="header">{t('plans.Yearly')}</div>
                </div>
                <div className="content">
                  <h2 className="ui header">
                    {`${yearlyProduct.offers[0].pricingPhases[
                      yearlyProduct.offers[0].pricingPhases.length - 1
                    ].priceMicros / 1000000
                      } ${yearlyProduct.offers[0].pricingPhases[
                        yearlyProduct.offers[0].pricingPhases.length - 1
                      ].currency
                      }`}
                  </h2>
                  <p className="ui header">{t('plans.YearlyDescription')}</p>
                </div>
                <div className="extra content">
                  <button
                    className="ui button primary"
                    onClick={() => {
                      handleOrder('yearly', yearlyProduct);
                    }}
                  >
                    {loading === 'yearly' ? (
                      <Loader size="tiny" active inline="centered" />
                    ) : (
                      t('buttons.btn_upgrade')
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
          {foreverProduct?.title && (
            <div className="column">
              <div className="ui card fluid">
                <div className="content">
                  <div className="header">{t('plans.Forever')}</div>
                </div>
                <div className="content">
                  <h2 className="ui header">
                    {`${foreverProduct.offers[0].pricingPhases[
                      foreverProduct.offers[0].pricingPhases.length - 1
                    ].priceMicros / 1000000
                      } ${foreverProduct.offers[0].pricingPhases[
                        foreverProduct.offers[0].pricingPhases.length - 1
                      ].currency
                      }`}
                  </h2>
                  <p className="ui header">{t('plans.ForeverDescription')}</p>
                </div>
                <div className="extra content">
                  <button
                    className="ui button primary"
                    onClick={() => {
                      handleOrder('forever', foreverProduct);
                    }}
                  >
                    {loading === 'forever' ? (
                      <Loader size="tiny" active inline="centered" />
                    ) : (
                      t('buttons.btn_upgrade')
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="row">
          <div className="column">
            <p className='text-center'>
              <a onClick={(ev) => {
                ev.preventDefault();
                if (window.cordova.InAppBrowser) {
                  window.cordova.InAppBrowser.open('https://monsyn.skynix.co/privacy-policy/', '_system');
                } else {
                  window.open('https://monsyn.skynix.co/privacy-policy/', '_system');
                }
              }} href='#'>Privacy Policy</a>
            </p>
            <p className='text-center'>
              <a onClick={(ev) => {
                ev.preventDefault();
                if (window.cordova.InAppBrowser) {
                  window.cordova.InAppBrowser.open('https://www.apple.com/legal/internet-services/itunes/dev/stdeula/', '_system');
                } else {
                  window.open('https://www.apple.com/legal/internet-services/itunes/dev/stdeula/', '_system');
                }
              }} href='#'>Terms of Use</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  subscriptions: state.subscriptions,
  user: state.user
});

export default connect(mapStateToProps)(Upgrade);
